import React from "react";
import TrophyIcon from "../../../shared-components/icons/TrophyIcon";
import { SmarticoTournamentPlayer } from "../../../interfaces/smartico";
import { useBotbLeaderboardContext } from "../context";

const LeaderboardRow = (props: { item: SmarticoTournamentPlayer; index: number; showTrophee?: boolean }) => {
  const { item, index, showTrophee = true } = props;
  const { getPrize } = useBotbLeaderboardContext();
  const prize = getPrize(item);

  return (
    <div className={`px-1.5 border-x-2 border-x-transparent lg:px-8 hover:bg-[#FFF6E7] hover:border-l-[#FF8200]`}>
      <div
        className={
          "min-h-[42px] lg:min-h-[54px] text-[13px] font-normal leading-4.5 lg:text-base lg:leading-5.5 grid grid-cols-4 items-center border-b border-b-black/8"
        }>
        {index < 3 && showTrophee ? (
          <div className="flex text-gray-1 text-left items-center gap-1.5 lg:gap-2.5">
            {index === 0 ? (
              <>
                <TrophyIcon className={"size-4.5 lg:size-5.5 text-[#D4BB00] shrink-0"} />
                <span className="inline-flex gap-1 items-start leading-none">{item.position}st</span>
              </>
            ) : index === 1 ? (
              <>
                <TrophyIcon className={"size-4.5 lg:size-5.5 text-[#BDBDBD] shrink-0"} />
                <span className="inline-flex gap-1 items-start leading-none">{item.position}nd</span>
              </>
            ) : (
              <>
                <TrophyIcon className={"size-4.5 lg:size-5.5 text-[#CC8100] shrink-0"} />
                <span className="inline-flex gap-1 items-start leading-none">{item.position}rd</span>
              </>
            )}
          </div>
        ) : (
          <span className="text-[#696971] font-normal text-left">{item.position}</span>
        )}
        <span className="font-normal text-center text-[#28282B]">{item.public_username}</span>
        <span className="font-normal text-center text-[#696971]">{item.scores}</span>
        {prize ? <span className="font-semibold text-center text-[#28282B]">{prize?.name}</span> : null}
      </div>
    </div>
  );
};

export default LeaderboardRow;
